import axios from "axios";

document.addEventListener('DOMContentLoaded', function () {
    const searchInput = document.getElementById('search-input');
    const searchResults = document.getElementById('search-results');

    searchInput.addEventListener('input', function () {
        const query = searchInput.value.trim();
        if (query.length > 2) { // Минимальная длина запроса для поиска
            axios.get('/mini-search', {
                params: {
                    search: query
                }
            })
                .then(response => {
                    if (response.data.length > 0) {
                        searchResults.innerHTML = '';
                        response.data.forEach(item => {
                            const link = document.createElement('a');
                            link.href = item.href; // Устанавливаем URL ссылки
                            link.textContent = item.name; // Устанавливаем текст ссылки
                            link.classList.add('search-result-item'); // Добавляем класс для стилизации
                            // link.target = '_blank'; // Открываем ссылку в новой вкладке (если нужно)
                            searchResults.appendChild(link);
                        });
                        searchResults.style.display = 'block'; // Показываем блок с результатами
                    }
                })
                .catch(error => {
                    console.error('Error fetching search results:', error);
                });
        } else {
            searchResults.innerHTML = '';
            searchResults.style.display = 'none'; // Скрываем блок, если запрос короткий
        }
    });

    // Скрываем блок с результатами, если кликнуть вне его
    document.addEventListener('click', function (event) {
        if (!searchInput.contains(event.target) && !searchResults.contains(event.target)) {
            searchResults.style.display = 'none';
        }
    });
});